import { render, staticRenderFns } from "./PictureInfo.vue?vue&type=template&id=39ccdc3f&scoped=true"
import script from "./PictureInfo.vue?vue&type=script&lang=ts"
export * from "./PictureInfo.vue?vue&type=script&lang=ts"
import style0 from "./PictureInfo.vue?vue&type=style&index=0&id=39ccdc3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ccdc3f",
  null
  
)

export default component.exports